import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useApiCall from '../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import ClientUsersService from '../../../../services/ClientUsersService';
import { ClientUserFromListApiType, MappedClientUserType } from '../../types';

export default function useLoadInternalUsers() {
  const [isLoadLoading, setIsLoadLoading] = useState(false);
  const [apiFetched, setApiFetched] = useState(true);
  const [clientUsers, setClientUsers] = useState<MappedClientUserType[]>([]);
  const [filteredClientUsers, setFilteredClientUsers] = useState<MappedClientUserType[]>([]);

  const { apiCall } = useApiCall();
  const user = useGetGeneralAppData();
  const { userProfile, userCode, companyCode } = user;

  const loadClientUsers = useCallback(async () => {
    await apiCall({
      apiToCall: ClientUsersService.listClientUsers,
      queryParams: { codUsu: userCode, perfilUsu: userProfile, codEmpresa: companyCode },
      onStartLoad: () => setIsLoadLoading(true),
      onEndLoad: () => setIsLoadLoading(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível recuperar os usuários (${response.msg})`);
          setApiFetched(false);
          return;
        }
        const clientUsersList: ClientUserFromListApiType[] = response.usuarios;
        const typeStringLiterals: {[key: number]: 'Administrador' | 'Padrão' | 'Motorista'} = {
          1: 'Administrador',
          2: 'Padrão',
          3: 'Motorista',
        };
        const mappedClientUsers: MappedClientUserType[] = clientUsersList.map((usr) => ({
          userCode: usr.codUsuAcesso,
          type: typeStringLiterals[usr.perfilUsuCad] ?? 'Tipo não identificado',
          cpf: usr.cpf,
          name: usr.nome,
          email: usr.email,
        }));
        setClientUsers(mappedClientUsers);
        setFilteredClientUsers(mappedClientUsers);
        setApiFetched(true);
      },
      catchAction: () => setApiFetched(false),
      catchMessage: 'Não foi possível recuperar os usuários. Por favor, tente novamente',
    });
  }, [apiCall, companyCode, userCode, userProfile]);

  useEffect(() => {
    if (companyCode) {
      loadClientUsers();
    }
  }, [companyCode, loadClientUsers]);

  function handleTryAgain() {
    loadClientUsers();
  }

  return {
    clientUsers,
    isLoadLoading,
    apiFetched,
    handleTryAgain,
    loadClientUsers,
    filteredClientUsers,
    setFilteredClientUsers,
  };
}
